import Action from '../Action'
import './styles/ModalTechDevice.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../LoadSimple';
import InputAdmin from '../InputAdmin';
import { useFetch } from '../../hooks/useFetch';
import Search from '../generales/Search';
import SelectorAdmin from '../SelectorAdmin'
import Modal from 'react-modal';
import { lang } from "../generales/traduction";
import { capitalizeFirstLetter } from "../../utils/utils";
import ModalCreateRelationTechDevice from './ModalCreateRelationTechDevice';
const CreateCisModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      background: '#ffffff !important',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width:'50%',
      height:'40%',
      padding:'20px'
    },
  };
const ModalCreateTechDevice =({languaje,server,dataCisConf,tecSelected,closCreateTechModal,search_devices})=>{
  const [CreateActionModalOpen, setCreateActionModalOpen] =useState(false);

  const [dataAction,setDataAction]=useState({data:[],loading:true,error:null})
  const [cisRelation,setCisRelation]=useState(0)
  const [relationResponse,setRelationResponse]=useState([])
  const [responseDetail,setResponseDetail]=useState({text:'',value:true})
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [arrayHost,setArrayHost]=useState([])
  const [arraySeverity,setArraySeverity]=useState([])
  const [disabled,setDisabled]=useState(true)
  const [msgError,setMsgError]=useState(lang[languaje]['ipNoValida'])
  const [IpValid,setIpValid]=useState(true)
  const [dataActionRel,setDataActionRel]=useState((dataAction.data.length==0)?arrayHost:dataAction.data.devices.concat(arrayHost))

  // console.log(dataAction.data.length)    

  // console.log(dataActionRel)
  // var dataActionRel=(dataAction.data.length==0)?arrayHost:dataAction.data.devices.concat(arrayHost)
  // var dataList=(searchTerm==='')?((dataAction.data.length==0)?[]:dataAction.data.devices):searchResults;
  var dataList=(searchTerm==='')?dataActionRel:searchResults;

  const [loading,setLoading]=useState(false)
  useEffect(()=>{
      // buscar_action_relations()
      // addRelation()
      buscar_action()
      
    },[])
  useEffect(()=>{
    if(arrayHost.length>0){
      setDisabled(false)
    }else{
      
      setDisabled(true)
    }
  },[arrayHost])
  const Guardar = () => {
    const arrayHostID=arrayHost.map(obj => obj.hostid);
    
      let method='POST'
      let url_add=''
     
      setDisabled(true)
      setLoading(true)
        const fetchDataPost = async () => {
          
       try {
         
            const response = await fetch(server.url+'/api/v1/cassia/services/techs/devices/', {
              method: 'POST',  
              headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
              body: JSON.stringify({
                "criticality_id": arraySeverity,
                  "hostid":arrayHostID ,
                "cassia_tech_id": tecSelected.cassia_tech_id
              }),
            });
          
            if (response.ok) {
              
              const data1 = await response.json();
             
            setLoading(false)
              search_devices()
              closCreateTechModal()
            
            } else { 
              const data1 = await response.json()
              
              setMsgError(data1.detail)
              setIpValid(false)
              setLoading(false)
              setArrayHost([])
              setArraySeverity([])
              throw new Error('Error en la solicitud');
            }
          } catch (error) {}
        };
    
        fetchDataPost();
        
  
  }
  function closCreateRelationModal() {

    setCreateActionModalOpen(false);
  }
  const buscar_action=()=>{
      
      
      setDataAction({data:dataAction.data,loading:true,error:null})
        const fetchDataPost = async () => {
          
       try {
         
          const response = await fetch(server.url+'/api/v1/cassia/services/techs/devices/'+tecSelected.cassia_tech_id, {
              method: 'GET',  
              headers: {
                'Content-Type': 'application/json',
                'accept': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
              },
            });
            
            if (response.ok) {
              const data1 = await response.json();
              setDataAction({data:data1.data,loading:false,error:null})
              setDataActionRel(data1.data.devices.concat(arrayHost))
              // setCreateActionModalOpen(true)
            } else {
              const data1 = await response.json();
              
              throw new Error('Error en la solicitud');
            }
          } catch (error) {
            console.error(error);
          }
        };
    
        fetchDataPost();
      
  }
  const removeObject = (hostid) => {
    const filteredObjects = dataList.filter(obj => obj.hostid !== hostid);
    setDataActionRel(filteredObjects)
    const filteredArray= arrayHost.filter(obj => obj.hostid !== hostid);
    setArrayHost(filteredArray);
  };

  const changeOption=(option,index)=>{
    setCisRelation(option.value)
  }

  const addRelation=async(e)=>{
      
      const formData = new URLSearchParams();
      formData.append("affected_ci_element_id", cisRelation);
      
    
      try {
        const response = await fetch(server.url+'/api/v1/cassia/ci_elements/relations/'+tecSelected.element_id, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/x-www-form-urlencoded",
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: formData
        });
       
        if (response.ok) {
          const data = await response.json();
          setRelationResponse(data)
          setResponseDetail({text:'',value:true})
          const timer = setTimeout(() => {
              setResponseDetail({text:'',value:true})
            }, 2000);
          // buscar_action_relations()
        } else {
          const data = await response.json();
          
          setResponseDetail({text:data.detail,value:false})
          throw new Error('Error en la solicitud');
        }
      
      } catch (error) {}
  }
  return(
      <>
      <div className="modal-GS-content">
           <div className='card-modal-gs modal-verificate'>
               <div className='head-card-modal-gs'>
                   <div className='title-head-card-modal-gs' style={{display:'flex',justifyContent:'space-around'}}>
                      <p>  &nbsp;</p><p>  {'   '+tecSelected.tech_name}</p>
                   </div>
               </div>
               <div className='content-card-modal-gs' style={{height:'100%'}} >
               <div className='body_info_gs_relation'>
       <div className='content-RelationTechDevice_relation-gs' style={{border: 'px solid #607582',boxShadow:'unset'}}>
               
               <div className='cont-RelationTechDevice-info-gs'>
               <ModalCreateRelationTechDevice  dataActionRel={dataActionRel} setDataActionRel={setDataActionRel} languaje={languaje} msgError={msgError} setMsgError={setMsgError} IpValid={IpValid} setIpValid={setIpValid} arraySeverity={arraySeverity} setArraySeverity={setArraySeverity} dataCisConf={dataCisConf} arrayHost={arrayHost} setArrayHost={setArrayHost} server={server}   tecSelected={tecSelected}  closCreateRelationModal={closCreateRelationModal}/> 
                   
                   </div>
               <div className='cont-RelationTechDevice-search-gs' style={{background:'transparent '}}>
             
             <>
               <div className='cont-search-relation-RelationTechDevice-gs hiddenPDF'>
                   
               {
                 <Search languaje={languaje} searchResults={searchResults} setSearchResults={setSearchResults} searchTerm={searchTerm} setSearchTerm={setSearchTerm} onSearch={()=>{}}  dataObject={dataList} setDataObject={setDataAction}/>
               }
               </div>
               <div className='cont-search-space-gs'>
                       <div className='msgErrorRelationGs' style={{color:(responseDetail.value)?'gree':'red'}}>
                           {responseDetail.text}
                       </div>
               </div>
               <div className='cont-search-buttons-gs hiddenPDF'>
               <Action disabled={disabled} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])} action={Guardar}  />
               </div>
             </>
               </div>
               <div className='cont-RelationTechDevice-table-relation-gs' style={{height:'50%'}}>
                   <div className='content-card-RelationTechDevice-relation-gs ' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                   
                   {
                       (loading)?<div style={{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}><LoadSimple></LoadSimple></div>:
                       
                       dataList.map((elemento, indice) => (
                       <div className='cont-elemen-relation-gs' >
                           <div className='elemen-relation-gs' style={{width:'95%'}}>
                              <div className='con-elemen-relation-info-gs'>
                               <p className='txtIp'>{elemento.hostid+' / '}</p>&nbsp;<p className='txtHost'>{elemento.name}</p>
                               </div>
                               <div className='con-elemen-relation-img-gs'>
                                   <div className='cont-img-field-acciones-gs' >
                                     {(elemento.cassia_tech_device_id==undefined)?
                                       <img className='img-field-acciones-gs img-relation' src='/iconos/delete.png' title='Eliminar'name='Eliminar' hostid={elemento.hostid} onClick={(e)=> {e.stopPropagation(); removeObject(elemento.hostid)}} />
                                     :''}
                                       </div>
                               </div>
                           </div>
                       </div>
                       ))
                   } 
                           
                   </div>
               </div>
           </div>
       </div>
                                  
               </div>
               </div>
       </div>
       <Modal
       isOpen={CreateActionModalOpen}
       // isOpen={false}
       // onAfterOpen={afterOpenExeption}
       // onRequestClose={closCreateRelationModal}
       style={CreateCisModalStyles}
       contentLabel="Example Modal2"
       // shouldCloseOnOverlayClick={false}
       >
         {/* <ModalCreateRelation server={server} registerIsValid={registerIsValid} setRegisterIsValid={setRegisterIsValid} tecSelected={tecSelected}  closCreateRelationModal={closCreateRelationModal}/> */}
   </Modal>
      </>
      
   )
}

export default ModalCreateTechDevice